import { useState, useEffect } from "react";
import axios from "axios";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Unstable_Grid2";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { StatesApi } from "apis/StatesApi";
import StatesTable from "components/Tables/StatesTable";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import TableHeader from "components/Table/TableHeader";
import TableElement from "components/Table/TableElement";
import { useDispatch, useSelector } from "react-redux";
import CircularIndeterminateModal from "../../utils/Loading";
import { setLoadingPanel } from "../../redux/features/loading";
import { ActionButton, Toolbar, TableCard, FormCard } from "utils/ui";

function States() {
  const navigate = useNavigate();
  const [states, setStates] = useState([]);
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.loadingReducer.isLoading);
  const [open, setOpen] = useState(false);
  const [stateData, setStateData] = useState({
    id: "",
    name: "",
    code: "",
    isActive: true,
  });
  const handleChange = (event) => {
    const { name, value } = event.target;
    setStateData({
      ...stateData,
      [name]: value,
    });
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleSave = () => {
    StatesApi.AddState(stateData)
      .then((res) => {
        toast("State Added", {
          type: "success",
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
        setOpen(false);
      })
      .catch((err) => {
        if (err?.response?.data) {
          toast(err.response.status + " " + err?.response?.data?.message, {
            type: "error",
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
        } else {
          toast(err?.response?.data?.message, {
            type: "error",
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
        }
        if (err.response.status === 401) {
          localStorage.clear();
          navigate("/");
        }
      });
  };

  const getStates = () => {
    dispatch(setLoadingPanel(true));
    StatesApi.GetStatesListByFilter()
      .then((res) => {
        setStates(res.data.data);
        dispatch(setLoadingPanel(false));
      })
      .catch((err) => {
        dispatch(setLoadingPanel(false));
        if (err?.response?.data) {
          toast(err.response.status + " " + err?.response?.data?.message, {
            type: "error",
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
        } else {
          toast(err?.response?.data?.message, {
            type: "error",
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
        }
        if (err.response.status === 401) {
          localStorage.clear();
          navigate("/");
        }
      });
  };

  useEffect(() => {
    axios.defaults.headers.common["x-api-key"] =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxOTU4NDk0NDY3NDY0MzE1NjQ5ODc0NTY0ODkyNiIsIm5hbWUiOiJTY2hlbWVzIEJvb29rIiwiaWF0IjoxNTE2MjM5MDIyfQ.uVUOR2U82nTjNccumsyggdScQh0DA5PdlwF_l0VUdfd";
    axios.defaults.headers.common["Authorization"] =
      localStorage.getItem("token");
    getStates();
  }, []);

  return (
    <>
      <CircularIndeterminateModal open={isLoading && !states.length} />
      <FormCard>
        <Toolbar>
          <ActionButton icon="fas fa-plus" onClick={handleClickOpen}>
            Add State
          </ActionButton>
        </Toolbar>
      </FormCard>

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Add State</DialogTitle>
        <DialogContent sx={{ p: { xs: 2, sm: 3 } }}>
          <Grid container columns={{ xs: 1, md: 12 }} spacing={2}>
            <Grid xs={6} md={6}>
              <TextField
                id="outlined-basic"
                sx={{ m: 2 }}
                label="Name"
                name="name"
                variant="outlined"
                value={stateData.name}
                onChange={handleChange}
              />
              <TextField
                id="outlined-basic"
                type="number"
                label="Code"
                name="code"
                variant="outlined"
                sx={{ m: 2 }}
                value={stateData.position}
                onChange={handleChange}
              />
            </Grid>
            <Grid xs={6} md={6}>
              <FormControl sx={{ m: 2 }}>
                <FormLabel id="demo-controlled-radio-buttons-group">
                  IsActive
                </FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group"
                  name="isActive"
                  value={stateData.isActive}
                  onChange={handleChange}
                >
                  <FormControlLabel
                    value={true}
                    control={<Radio />}
                    label="True"
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio />}
                    label="False"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSave}>Save</Button>
        </DialogActions>
      </Dialog>

      <TableCard>
        <div className="p-0">
          <div className="overflow-x-auto">
          <table className="w-full border-collapse" style={{ minWidth: 500 }}>
            <thead>
              <tr>
                <TableHeader heading="" />
                <TableHeader heading="Name" />
                <TableHeader heading="Code" />
                <TableHeader heading="Is Active" />
              </tr>
            </thead>
            <tbody>
              {states?.map((s, i) => {
                return (
                  <tr
                    key={i}
                    style={{ transition:"background 100ms" }} onMouseEnter={(e)=>e.currentTarget.style.background="#F8FAFC"} onMouseLeave={(e)=>e.currentTarget.style.background="transparent"}
                  >
                    <TableElement value={i + 1} />
                    <TableElement value={s.name} />
                    <TableElement value={s.code} />
                    <TableElement value={s.isActive} type="boolean" />
                  </tr>
                );
              })}
            </tbody>
          </table>
          </div>
        </div>
      </TableCard>
    </>
  );
}

export default States;
